<header id="page-topbar">
    <div class="navbar-header">
        <div class="d-flex">
            <!-- LOGO -->
            <div class="navbar-brand-box">
                <a href="/" class="logo logo-dark">
                    <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22">
          </span>
                    <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="17">
          </span>
                </a>

                <a href="/" class="logo logo-light">
                    <span class="logo-sm">
            <img src="assets/images/logo-light.svg" alt="" height="22">
          </span>
                    <span class="logo-lg">
            <img src="assets/images/logo-light.png" alt="" height="39">
        </span>
                </a>
            </div>

            <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

            <!-- App Search-->

        </div>

        <div class="d-flex">

            <div class="dropdown d-inline-block d-lg-none ml-2" ngbDropdown>
                <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" data-toggle="dropdown" aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" ngbDropdownMenu aria-labelledby="page-header-search-dropdown">


                </div>
            </div>





            <div class="dropdown d-none d-lg-inline-block ml-1">
                <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
            </div>

            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" ngbDropdownToggle>
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge badge-danger badge-pill">{{total}}</span>
        </button>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
                    <div class="p-3">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="m-0"> Notificaciones</h6>
                            </div>
                            <div class="col-auto">
                                <a href="javascript: void(0);" class="small"> Ver Todos</a>
                            </div>
                        </div>
                    </div>
                    <perfect-scrollbar style="position: relative; height: 230px;" [config]="configData">
                        <a *ngFor="let table of notificaciones | async" href="" class="text-reset notification-item">
                            <div class="media">
                                <div class="avatar-xs mr-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                              <i class="bx bx-cart"></i>
                            </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">{{table.asunto}}</h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">{{table.descripcion}}</p>
                                        <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{table.tiempo}}</p>
                                    </div>
                                </div>
                            </div>
                        </a>

                    </perfect-scrollbar>
                    <div class="p-2 border-top">
                        <a class="btn btn-sm btn-light btn-block text-center" href="javascript:void(0)">
                            <i class="mdi mdi-arrow-down-circle mr-1"></i> Load More..
                        </a>
                    </div>
                </div>
            </div>

            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
                  <i class="fas fa-user-tie"></i>
                  <!-- <span class="d-none d-xl-inline-block ml-1">{{currentUser.razonSocial}}-</span> -->
          <span class="d-none d-xl-inline-block ml-1">{{currentUser.Nombre}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                    <!-- item-->
                    <a class="dropdown-item" routerLink="/contacts/profile"><i class="bx bx-user font-size-16 align-middle mr-1"></i>
            Perfil</a>
                    <a class="dropdown-item" href="javascript: void(0);" (click)=openModal(content)><i
              class="bx bx-wallet font-size-16 align-middle mr-1"></i> Cambiar Contraseña</a>
                    <!--  <a class="dropdown-item d-block" href="javascript: void(0);"><span
              class="badge badge-success float-right">11</span><i
              class="bx bx-wrench font-size-16 align-middle mr-1"></i>Nuevo</a>
          <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-lock-open font-size-16 align-middle mr-1"></i> Lock
            screen</a> -->
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Cerrar Session</a>
                </div>
            </div>


        </div>
    </div>
    <ng-template #content role="document" let-modal>
        <div class="modal-header">
            <h5 class="modal-title mt-0">Cambiar contraseña</h5>
            <button type="button" class="close" aria-hidden="false" (click)="modal.close('Ok click')">×</button>
        </div>
        <form class="needs-validation" (ngSubmit)="formSubmit()" [formGroup]="tooltipvalidationform">

            <div class="modal-body">
                <div class="form-group row">
                    <label for="example-text-input" class="col-md-2 col-form-label">Actual</label>
                    <div class="col-md-10">
                        <input type="text" class="form-control" id="validationTooltip01" placeholder="Contraseña actual" [(ngModel)]='actual' formControlName="actual" [ngClass]="{'is-invalid': formsubmit && formData.actual.errors}">
                        <div *ngIf="formsubmit && formData.actual.errors" class="invalid-tooltip">
                            <span *ngIf="formData.actual.errors.required">Ingrese contraseña Actual.</span>

                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="example-search-input" class="col-md-2 col-form-label">Nueva</label>
                    <div class="col-md-10">
                        <input type="text" class="form-control" id="validationTooltip02" placeholder="Contraseña nueva" [(ngModel)]='nueva' formControlName="nueva" [ngClass]="{'is-invalid': formsubmit && formData.nueva.errors}">
                        <div *ngIf="formsubmit && formData.nueva.errors" class="invalid-tooltip">
                            <span *ngIf="formData.nueva.errors.required">Ingrese contraseña Nueva.</span>
                            <span *ngIf="formData.nueva.errors.minlength">Contraseña minimo 6
            caracteres.</span>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="example-email-input" class="col-md-2 col-form-label">Confirmar</label>
                    <div class="col-md-10">
                        <input type="text" class="form-control" id="validationTooltip03" placeholder="Confirmar contraseña" [(ngModel)]='confirma' formControlName="confirma" [ngClass]="{'is-invalid': formsubmit && formData.confirma.errors}">
                        <div *ngIf="formsubmit && formData.confirma.errors" class="invalid-tooltip">
                            <span *ngIf="formData.confirma.errors.required">Confirmar Contraseña.</span>
                        </div>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="modal.close('Ok click')">Cerar</button>
                <button type="submit" class="btn btn-primary">Cambiar</button>
            </div>
        </form>
    </ng-template>
</header>
